export const SpinBadge = ({ className = "" }) => (
  <div className={`spin-slow ${className}`} data-testid="hero-spin-badge" aria-hidden="true">
    <svg viewBox="0 0 120 120" className="h-full w-full drop-shadow-[0_0_18px_rgba(163,230,53,0.35)]">
      <defs>
        <path id="etm-badge-circle" d="M60,60 m-46,0 a46,46 0 1,1 92,0 a46,46 0 1,1 -92,0" fill="none" />
      </defs>
      <text
        fill="#A3E635"
        style={{ fontSize: "11px", letterSpacing: "2.4px", fontFamily: "'JetBrains Mono', monospace", fontWeight: 700 }}
      >
        <textPath href="#etm-badge-circle">ETN CUSTOMZ • EAST TN • LIFTS • LIGHTS •</textPath>
      </text>
      <path d="M63 38 L52 62 h7 L55 82 L70 56 h-8 L66 38 z" fill="#A855F7" />
    </svg>
  </div>
);

export const TreadDivider = () => (
  <div className="tread-strip h-9 w-full" aria-hidden="true" data-testid="tread-divider" />
);

export const StatusDot = () => (
  <span className="relative flex h-2 w-2" aria-hidden="true">
    <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-volt opacity-60" />
    <span className="relative inline-flex h-2 w-2 rounded-full bg-volt" />
  </span>
);
